import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { createUseStyles } from 'react-jss';

const styles: ComponentStylesProps<boolean> = {
  spinnerWrapper: (semiTransparentBg) => ({
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    backgroundColor: semiTransparentBg ? 'rgba(255,255,255,0.5)' : 'transparent',
  }),
};
const createStyles = createUseStyles(styles);

export { styles, createStyles };
